import { VUpdateDevicePublicKeyRequest, VUpdateDevicePublicKeyResponse, VUserExistResponse } from '@datarock/protobuffers';
import { EncryptedEndpoint } from './Encrypted';
class DevicesPublicKeyEndpoint extends EncryptedEndpoint {
    async getRequestInit({ manufacturerPublicKey }) {
        const requestBytes = VUpdateDevicePublicKeyRequest.encode({
            manufacturerPublicKey
        }).finish();
        return await super.getRequestInit(requestBytes);
    }
    async process(value, ...args) {
        const responseBytes = await super.process(value, ...args);
        return VUpdateDevicePublicKeyResponse.decode(responseBytes);
    }
}
export const devicesPublicKeyEndpoint = new DevicesPublicKeyEndpoint({
    path: '/pb/accounts/devices/publickey',
    method: 'PATCH',
    sideEffect: true,
    body: {},
    schema: VUserExistResponse
});
